export const getThirdpartyDesclaimer = (thirdParty) => {
  let desclaimer = ''
  switch (thirdParty) {
    case 'Google':
      desclaimer = `By signing in, you agree to let Asda share your Asda account information, including your order history and profile, with Google to personalize your shopping experience on Google and facilitate shopping transactions. The <a href='https://policies.google.com/privacy' target='_blank'>Google Privacy Policy</a> explains how Google will treat your data within this experience`
      break
    case 'WHISK':
      desclaimer = `By signing in, you agree to let Asda share your Asda account information with Whisk to facilitate shopping interactions using the Whisk service. The <a href='https://whisk.com/privacy/' target='_blank'>Whisk Privacy Policy</a> explains how Whisk will treat your data.`
      break
    case 'MSM':
      desclaimer = `By signing in, you agree to let Asda share your Asda account information with mySupermarket to facilitate shopping interactions using the mySupermarket service. The <a href='http://help.mysupermarket.co.uk/index.php/knowledgebase/privacy-policy/' target='_blank'>mySupermarket Privacy Policy</a> explains how mySupermarket will treat your data.`
      break
    case 'APG':
      desclaimer = `By signing in to the Asda Price Guarantee site, your data will be used in accordance with <a href='https://www.asda.com/privacy/your-information/customer-information/online/asda-grocery-home-shopping' target='_blank'>Asda's Groceries (Home Shopping) Privacy Policy.</a>`
      break
    default:
      desclaimer = ``
  }
  return { __html: desclaimer }
}

const clientIdMap = {
  giftcards: [
    'd6ac62d9-f36f-45bb-ae2c-f6379c1e6330',
    '693842ee-c6e4-40e0-8551-7c883a48b650',
  ],
}

export const checkClientIdWithOrigin =
    (requestOrigin, clientId) => clientIdMap[requestOrigin].includes(clientId)
